
import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import { Text } from 'components/text';

const TextTableCell = ({
  color,
  style,
  colSpan,
  align,
  padding,
  children,
  fontFamily,
  fontWeight,
  fontSize,
  ...rest
}) => (
  <TableCell
    style={{ height: 40, paddingTop: 8, paddingBottom: 8 }}
    {...rest}
    colSpan={colSpan}
    align={align}
    padding={padding}
  >
    <Text color={color} fontWeight={fontWeight} fontSize={fontSize} fontFamily={fontFamily}>{children}</Text>
  </TableCell>
);

TextTableCell.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  colSpan: PropTypes.number,
  fontFamily: PropTypes.string,
  fontWeight: PropTypes.string,
  fontSize: PropTypes.number,
  padding: PropTypes.string,
  style: PropTypes.shape({}),
};

TextTableCell.defaultProps = {
  align: 'left',
  children: null,
  color: 'gray.9',
  colSpan: 1,
  fontFamily: 'sans',
  fontWeight: 'normal',
  fontSize: 3,
  padding: 'default',
  style: {},
};

export default TextTableCell;
